/* eslint-disable no-nested-ternary */
import { object } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../Button";
import * as style from "./styles.module.scss";

const FeedbackScreen = ({ state }) => {
  const {
    result,
    numQuestions,
    passed,
    retakeLink,
    testTitle,
    cancelLink,
    retryCount,
    retryLimit,
  } = state;
  const resultText = passed ? "Pass" : "Fail";
  const scoreText = `Your score ${result} / ${numQuestions}`;
  const imgSrc = passed
    ? "/images/well_done.svg"
    : "/images/timesheet-error.svg";

  const retryDisabled = retryLimit - retryCount <= 0;
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">{testTitle} - Feedback </h2>
        <div>
          <section className="section-body p-0">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h2 className="styles__resource__title___3swKq text-left">
                  {resultText}
                </h2>
                <span className="mb-2" style={{ fontSize: "1.7em" }}>
                  {scoreText}
                </span>
                {passed ? (
                  <h3>Great Work! </h3>
                ) : !retryDisabled ? (
                  <h3>Retries left - {retryLimit - retryCount} </h3>
                ) : (
                  <h3>
                    Unfortunately, you have reached the retake limit for this
                    test.
                  </h3>
                )}
              </div>
              <img
                className={style.img}
                style={{
                  display: "flex",
                  alignSelf: "flex-end",
                  marginBottom: "15px",
                  marginRight: "20px",
                }}
                src={imgSrc}
              />
            </div>
            <div className={style.container__buttons}>
              <Link
                style={{ textDecoration: "none" }}
                to={`/profile/edit/${cancelLink}`}
              >
                <Button classes="btn  btn-outline-dark text-decoration-none">
                  Back
                </Button>
              </Link>
              {!passed && !retryDisabled ? (
                <Link
                  style={{ textDecoration: "none" }}
                  to={`/profile/edit/${retakeLink}`}
                >
                  <Button classes="btn btn-block btn-primary">Retake</Button>
                </Link>
              ) : null}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

FeedbackScreen.propTypes = {
  state: object,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, null);
export default withRedux(FeedbackScreen);
